'use es6';

import { Record } from 'immutable';
import { DeliveryMethod } from '../../lib/Constants';
export default Record({
  id: null,
  budget: null,
  name: null,
  deliveryMethod: DeliveryMethod.STANDARD
});